<div style="background-color:white; padding:10px;">
	<div style="padding:10px; display: flex;">
		<span style="font-weight:bold; font-size:16px;color:inherit;">{{videoTitle}}</span>
		<div style="margin-left: auto;"><span role="button" class="jmCloseBtn" (click)="closeModal($event)"></span></div>
	</div>
	<div id="occupationVideo">
		<video crossorigin="anonymous" preload="auto" autoplay="autoplay" controls="controls" class="w-100 h-100" poster="assets/images/videoPoster.png">
			<source [src]="video.VideoFile" type="video/mp4" />
			<track [src]="video.Caption.English" label="English subtitles" kind="subtitles" srclang="en" default>
			<track [src]="video.Caption.Spanish" label="Spanish subtitles" kind="subtitles" srclang="es">
			"Your browser does not support the video tag."
		</video>
	</div>
	<div style="background-color:white; font-size: 11px; width:100%; height:30px; padding:10px;">
		<img src="assets/images/career-onestop.jpg" style="vertical-align: middle; width:16px; height:16px;" />
		Produced by <a href="https://www.careeronestop.org/" target="_blank">CareerOneStop</a>
	</div>
</div>
